import type { PositionResolutionCode, PositionResolutionView } from "@/api";

export type PositionResolutionTarget = "facts" | "catalog";

export interface PositionResolutionPresentation {
  readonly titleKey: string;
  readonly bodyKey: string;
  readonly actionKey: string;
  readonly target: PositionResolutionTarget;
}

const TARGET: Readonly<Record<PositionResolutionCode, PositionResolutionTarget>> = {
  REVIEW_DIETARY_FACTS: "facts",
  REVIEW_REQUEST_FACTS: "facts",
  REVIEW_CATALOG: "catalog",
  COMPLETE_PROPOSAL: "catalog",
};

export function positionResolutionPresentation(
  resolution: PositionResolutionView | null | undefined,
): PositionResolutionPresentation | null {
  if (
    !resolution
    || !Object.prototype.hasOwnProperty.call(TARGET, resolution.code)
  ) return null;
  return {
    titleKey: `ws.positionResolution.title.${resolution.code}`,
    bodyKey: `ws.positionResolution.body.${resolution.code}`,
    actionKey: `ws.positionResolution.action.${resolution.code}`,
    target: TARGET[resolution.code],
  };
}
